/**************************高拍仪相关接口分装 ************************************/
import axios from 'axios';
import '../util/index.js';
import VM from '../main';
import vm from 'vue';
import { Loading } from 'element-ui';
import agreementDialog from '@/pages/quickRoutes/agreement/components/agreementDialog';
const photoHttp = axios.create({
  baseURL: Util.getGwRoot,
  timeout: 600000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }
});
let requestNum = 0;
let loadingService = null;

// pending请求数量
// var requestNum = 0
photoHttp.interceptors.request.use(
  config => {
    // 如果pending请求数量等于1，弹出loading, 防止重复弹出
    requestNum++;
    if (requestNum == 1 && !config.closeLoading) {
      loadingService = Loading.service({
        text: '正在努力加载中....',
        background: 'rgba(0, 0, 0, 0)'
      });
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
var curMsg = '';
function alertMessageInfo(msg) {
  if (msg == curMsg) {
  } else {
    curMsg = msg;
    VM.$message({
      message: msg,
      onClose: function() {
        curMsg = '';
      }
    });
  }
}
photoHttp.interceptors.response.use(
  res => {
    // 如果pending请求数量等于0，关闭loading
    --requestNum;
    if (requestNum === 0) {
      loadingService.close();
    }
    return res.data;
  },
  error => {
    // 如果pending请求数量等于0，关闭loading
    --requestNum;
    if (requestNum === 0) {
      loadingService.close();
    }
    return Promise.reject(new Error(error));
    // VM.$message.error(`网络异常`);
  }
);

// 重写get，delete方法
let getFn = photoHttp.get;
let delFn = photoHttp.delete;

photoHttp.get = function(url, data = {}, config = {}) {
  config.params = data;
  return getFn(url, config);
};
photoHttp.delete = function(url, data = {}, config = {}) {
  config.data = data;
  return delFn(url, config);
};

export { photoHttp };
